import { FC, ReactNode, useEffect, useId } from 'react';
import styled from './index.module.scss';

interface IProps {
    icon: ReactNode;
    desc: string;
    subtitle?: string;
    inset?: boolean;
}

const Header: FC<IProps> = ({ icon, desc, subtitle, inset }) => {
    const id = useId().replaceAll(':', 'a'); // 因为：无法使用选择器

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneA = AniContainer.create({
                asyncFromTo: [
                    [`#${id} .title .icon`, { scale: 1.5 }, { scale: 1 }, 1],
                    // [`#${id} .title .desc`, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 1],
                    // [`#${id} .subtitle`, { opacity: 0 }, { opacity: 1 }, 1],
                ],
                asyncTimeLine: [0],
                triggerElement: `#${id}`,
                triggerHook: 1,
                offset: '30%',
                duration: '50%',
            });
            AniContainer.scrollHandle(); //执行一次初始化
            return () => AniContainer.removeScene(sceneA);
        }
    }, []);

    return (
        <div className={styled.Header} id={id}>
            <div className="title">
                <div className={`icon ${inset && 'inset'}`}>{icon}</div>
                <p className={`desc middle-central ${inset && 'inset'}`}>{desc}</p>
            </div>
            {subtitle && <p className="subtitle middle-central">{subtitle}</p>}
        </div>
    );
};

export default Header;
